<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jVQrIK/tc-custom/9781467464994.jpg?1744431012522" alt="This image is the cover for the book Reading Theology Wisely"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reading Theology Wisely
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Could reading theology turn you toward God in astonished worship? Could it enliven your reading of Scripture? Could it move you toward your true self in Christ? Could it turn you toward your neighbors in self-giving love? Could it unmask your prejudices? Could it dethrone your idols? Should we hope for anything less?”</b> </p><p>In this illuminating introduction, Kent Eilers invites Christians of all backgrounds into the practice of reading theology. With a classroom-tested approach, Eilers shows how theology can form the imagination and enhance“the human capacity for perceiving reality beyond the surface of things”—allowing Christians to see and experience God in the everyday. He then guides readers through the essential facets of theology so that it can begin to feel familiar and accessible, even (and especially) to beginners with no prior experience. </p><p>Written conversationally and illustrated beautifully with art by Chris Koelle, <i>Reading Theology Wisely </i>is welcoming and engaging in every respect. Eilers takes a well-rounded approach to his subject, utilizing Scripture and the wisdom of past thinkers as well as references to film and the arts—including a special emphasis on architecture as part of an ongoing metaphor of “inhabiting texts” as we do physical spaces. Each chapter ends with a prayer and questions for reflection and discussion, followed by a “theology lab” in which readers can put the content of the preceding chapter into practice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kent Eilers, Chris Koelle
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Kent Eilers</B>&#160;is professor of theology at Huntington University in Fort Wayne, Indiana. His other books include&#160;<I>Theology as Retrieval: Receiving the Past, Renewing the Church</I>&#160;and&#160;<I>The Grammar of Grace: Readings from the Christian Tradition.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?456be506